import React from "react";

/**
 * AxisDiagramTABO — diagramma SVG del cerchio graduato TABO (0°-180°) con linea visuale
 * sull'asse selezionato. Si aggiorna automaticamente quando AXIS cambia.
 */
export default function AxisDiagramTABO({ axis, label }) {
  // TABO: 0° destra (lato temporale OD, nasale OS), 90° in alto, 180° sinistra
  // SVG ruota di -axis° perché Y va verso il basso
  const a = Number(axis);
  const valid = Number.isFinite(a) && a >= 0 && a <= 180;
  const angRad = valid ? (a * Math.PI) / 180 : 0;
  const r = 36;
  const cx = 50, cy = 50;
  // linea visuale: da (cx - r·cos, cy + r·sin) a (cx + r·cos, cy - r·sin)
  const x1 = cx - r * Math.cos(angRad);
  const y1 = cy + r * Math.sin(angRad);
  const x2 = cx + r * Math.cos(angRad);
  const y2 = cy - r * Math.sin(angRad);
  return (
    <div className="flex items-center gap-2" data-testid={`tabo-${(label || "axis").toLowerCase()}`}>
      <svg viewBox="0 0 100 100" className="w-16 h-16">
        {/* Cerchio graduato */}
        <circle cx={cx} cy={cy} r={r} fill="white" stroke="#94A3B8" strokeWidth="1" />
        {/* Tacche ogni 30° */}
        {[0, 30, 60, 90, 120, 150, 180].map((deg) => {
          const rad = (deg * Math.PI) / 180;
          const tx1 = cx - (r - 4) * Math.cos(rad);
          const ty1 = cy + (r - 4) * Math.sin(rad);
          const tx2 = cx - r * Math.cos(rad);
          const ty2 = cy + r * Math.sin(rad);
          return <line key={deg} x1={tx1} y1={ty1} x2={tx2} y2={ty2} stroke="#CBD5E1" strokeWidth="0.7" />;
        })}
        {/* Etichette 0/90/180 */}
        <text x={cx + r + 3} y={cy + 1.5} fontSize="6" fill="#64748B" textAnchor="start">0°</text>
        <text x={cx} y={cy - r - 1.5} fontSize="6" fill="#64748B" textAnchor="middle">90°</text>
        <text x={cx - r - 3} y={cy + 1.5} fontSize="6" fill="#64748B" textAnchor="end">180°</text>
        {/* Linea asse */}
        {valid && (
          <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#F0763C" strokeWidth="2.2" strokeLinecap="round" />
        )}
        {/* centro */}
        <circle cx={cx} cy={cy} r="1.2" fill="#0F2A4D" />
      </svg>
      <div className="text-[10px] text-slate-500 leading-tight">
        <div className="font-bold text-brand-navy">{label}</div>
        <div>Asse: <span className="font-bold text-brand-orange">{valid ? `${a}°` : "—"}</span></div>
        <div className="opacity-70">Notazione: TABO</div>
      </div>
    </div>
  );
}
